import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    get_company: {},
    nav_list: [],
    first: {},
  },
  mutations: {
    // 导航
    SETNAVLIST(state, value) {
      state.nav_list = value;
    },
    // 联系我们
    SETCOMPANY(state, value) {
      state.get_company = value;
    },
    // 点哪用哪
    SETFIRST(state, value) {
      state.first = value;
    },
  },
  actions: {
    // 导航
    GETNAVLIST({ commit }, name) {
      commit("SETNAVLIST", name);
    },
    // 点哪用哪
    GETFIRST({ commit }, name) {
      commit("SETFIRST", name);
    },
    // 联系我们
    GETCOMPANY({ commit }, name) {
      commit("SETCOMPANY", name);
    },
  },
});
